<template lang="pug">
form.form-horizontal
  .form-group(v-for='(item, index) in items')
    label.col-md-12 {{item.label}}
      .col-md-12
      el-input(type='text', :value="value[item.name]",@input="inputData($event,item.name)")
        //el-input(type='text', v-model="inputedValue[item.name]",v-on:input="inputData")
</template>
    
<script>
export default {
  name: 'Top',
  props: ['value'],
  data () {
    return {
      locale_url: {
        ja: '',
        en: '',
        cn: '',
        kr: ''
      },
      items: [
        {
          name: 'image-width',
          label: 'image_width'
        },
        {
          name: 'image-height',
          label: 'image_height'
        },
        {
          name: 'image-alt',
          label: 'image_alt'
        },
        {
          name: 'data-frames',
          label: 'data-frames'
        },
        {
          name: 'data-x',
          label: 'data-x'
        },
        {
          name: 'data-y',
          label: 'data-y'
        },
        {
          name: 'data-hoffset',
          label: 'data-hoffset'
        },
        {
          name: 'data-voffset',
          label: 'data-voffset'
        },
        {
          name: 'data-width',
          label: 'data-width'
        },
        {
          name: 'data-height',
          label: 'data-height'
        },
        {
          name: 'data-basealign',
          label: 'data-basealign'
        },
        {
          name: 'data-visibility',
          label: 'data-visibility'
        }
      ]
    }
  },
  components: {
  },
  methods: {
    inputData (event, name) {
      console.log(event)
      this.value[name] = event
    }
  }
}
</script>
    
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/components/swan/layer/parameter.vue